
(function () {
  function initialiseBlackFridayHero(root) {
    if (!root || root.dataset.bfInitialised === 'true') return;

    root.dataset.bfInitialised = 'true';

    const launchRaw = root.dataset.launch;
    const launchTime = Date.parse(launchRaw);

    const preSale = root.querySelector('.bf-presale-content');
    const liveSale = root.querySelector('.bf-live-content');
    const timer = root.querySelector('.bf-flip-timer');

    if (!preSale || !liveSale || !timer) return;

    const groups = {
      days: timer.querySelector('[data-unit="days"] [data-value]'),
      hours: timer.querySelector('[data-unit="hours"] [data-value]'),
      minutes: timer.querySelector('[data-unit="minutes"] [data-value]'),
      seconds: timer.querySelector('[data-unit="seconds"] [data-value]')
    };

    let interval = null;

    function showLiveSale() {
      preSale.hidden = true;
      liveSale.hidden = false;

      if (interval !== null) {
        clearInterval(interval);
        interval = null;
      }
    }

    function updateCountdown() {
      const forceLive = root.dataset.forceLive === 'true';
      const now = Date.now();

      if (forceLive || now >= launchTime) {
        showLiveSale();
        return;
      }

      preSale.hidden = false;
      liveSale.hidden = true;

      const distance = Math.max(0, launchTime - now);
      const totalSeconds = Math.floor(distance / 1000);

      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60
      };

      Object.keys(groups).forEach(function (unit) {
        if (groups[unit]) {
          groups[unit].textContent = String(values[unit]).padStart(2, '0');
        }
      });
    }

    if (!Number.isFinite(launchTime)) {
      console.error(
        'Black Friday hero: invalid launch timestamp.',
        launchRaw
      );

      timer.textContent = 'Please check the launch time in the theme editor.';
      return;
    }

    updateCountdown();

    if (!liveSale.hidden) return;

    interval = window.setInterval(updateCountdown, 1000);
  }


function initialiseAllBlackFridayHeroes(scope) {
  const searchRoot = scope || document;

  if (searchRoot.matches?.('.black-friday-hero')) {
    initialiseBlackFridayHero(searchRoot);
  }

  searchRoot.querySelectorAll?.('.black-friday-hero').forEach(
    initialiseBlackFridayHero
  );
}

function startBlackFridayHeroes() {
  initialiseAllBlackFridayHeroes(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startBlackFridayHeroes);
} else {
  startBlackFridayHeroes();
}

document.addEventListener('shopify:section:load', function (event) {
  initialiseAllBlackFridayHeroes(event.target);
});

document.addEventListener('click', async function(event) {
  const button = event.target.closest('.bf-copy-code');

  if (!button) return;

  const code = button.dataset.copyCode;
  if (!code) return;

  try {
    await navigator.clipboard.writeText(code);

    button.textContent = 'COPIED!';
    button.classList.add('is-copied');

    setTimeout(function() {
      button.textContent = 'COPY CODE';
      button.classList.remove('is-copied');
    }, 2000);

  } catch (error) {
    button.textContent = 'COPY FAILED';

    setTimeout(function() {
      button.textContent = 'COPY CODE';
    }, 2000);
  }
});

})();